import { render } from "./WebGLOrb.vue?vue&type=template&id=24555d29&scoped=true"
import script from "./WebGLOrb.vue?vue&type=script&lang=js"
export * from "./WebGLOrb.vue?vue&type=script&lang=js"

import "./WebGLOrb.vue?vue&type=style&index=0&id=24555d29&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24555d29"]])

export default __exports__